import { isValidCnpj, normalizeCnpjInput, onlyCnpjDigits } from '../../../services/validCnpj';

const CARRIER_FEATURE = 'config.carriers';
const NAME_MAX_LENGTH = 100;

export const CARRIER_MESSAGES = {
  listTitle: 'Operadoras',
  newTitle: 'Nova operadora',
  editTitle: 'Editar operadora',
  nameLabel: 'Nome',
  cnpjLabel: 'CNPJ',
  actionsLabel: 'Ações',
  newButton: 'Nova operadora',
  refreshButton: 'Atualizar lista',
  saveButton: 'Salvar',
  cancelButton: 'Cancelar',
  editTooltip: 'Editar',
  deleteTooltip: 'Excluir',
  empty: 'Nenhuma operadora cadastrada',
  created: 'Operadora cadastrada com sucesso.',
  updated: 'Operadora atualizada com sucesso.',
  deleted: 'Operadora excluída com sucesso.',
  loadFailed: 'Erro ao carregar operadoras.',
  saveFailed: 'Erro ao salvar operadora.',
  deleteFailed: 'Erro ao excluir operadora.',
  notFound: 'Operadora não encontrada.',
  backToList: 'Voltar para Operadoras',
  deleteTitle: 'Excluir operadora',
  deleteConfirm: 'Excluir',
  deleteLoading: 'Excluindo...',
  nameRequired: 'Nome é obrigatório.',
  nameTooLong: 'Nome deve ter no máximo 100 caracteres.',
  cnpjRequired: 'CNPJ é obrigatório.',
  cnpjInvalid: 'CNPJ inválido.',
  duplicateCnpj: 'CNPJ já cadastrado para outra operadora.',
};

export const carrierFormError = ({ name, cnpj } = {}) => {
  const trimmedName = typeof name === 'string' ? name.trim() : '';
  if (!trimmedName) return CARRIER_MESSAGES.nameRequired;
  if (Array.from(trimmedName).length > NAME_MAX_LENGTH) return CARRIER_MESSAGES.nameTooLong;
  if (!normalizeCnpjInput(cnpj)) return CARRIER_MESSAGES.cnpjRequired;
  if (!isValidCnpj(cnpj)) return CARRIER_MESSAGES.cnpjInvalid;
  return null;
};

export const carrierPermissions = (hasFeatureFn) => ({
  canCreate: !!hasFeatureFn(CARRIER_FEATURE, 'create'),
  canEdit: !!hasFeatureFn(CARRIER_FEATURE, 'edit'),
  canDelete: !!hasFeatureFn(CARRIER_FEATURE, 'delete'),
});

export const carrierTotalLabel = (count) => `Total: ${count} operadora(s)`;

export const carrierDeleteQuestion = (carrierName) =>
  `Tem certeza que deseja excluir a operadora ${carrierName}? Esta ação não pode ser desfeita.`;

export const buildCarrierPayload = (values, tenant) => ({
  tenant,
  name: String(values.name || '').trim(),
  cnpj: onlyCnpjDigits(values.cnpj),
});

export const resultErrorMessage = (result, fallback) => (result && result.error) || fallback;
